import React, { Fragment } from 'react';
import { useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  Form,
  Formik,
  Field,
  ErrorMessage
} from 'formik';
import { Messages } from '../../components/layout/Messages/Messages';
import { Auth } from '../layout/Auth';
import { LoginLinks } from '../../components/layout/Auth/LoginLinks';
import { PasswordField } from '../../components/pages/auth/PasswordField';
import { requestVerify } from '../../store/actions/user';
import { VerifyAdminSchema } from '../../helpers/schemas';
import {
  goToForgotPassword,
  goToLogin
} from '../../helpers/location';
import * as types from "../../store/actions/types";

import * as adminUserApi from '../../api/admin/users';
import './VerifyAdmin.scss';

function VerifyAdminComponent(props) {

  const { goToForgotPassword, goToLogin } = props;

  const url = new URLSearchParams( useLocation().search );

  const [ expires, signature ] = [
    url.get( 'expires' ),
    url.get( 'signature' )
  ]
  const { id, hash } = props.match.params;
  const verify_admin_user = (values) => {
    adminUserApi.verifyAdmin( values );
  }

  return (
    <div className="verify-admin-page">
      <Auth title={<FormattedMessage id="app.admin.verify.admin_verify_title"/>}
            lead={<FormattedMessage
              id="app.admin.verify.admin_verify_description"/>}>
        <Formik
          initialValues={{
            password: '',
            password_confirm: '',
            signature,
            hash,
            id,
            expires
          }}
          validationSchema={VerifyAdminSchema}
          validateOnChange={false}
          onSubmit={values => verify_admin_user( values )}
        >
          {(formik_props) => (
            <Fragment>
              <Messages
                color="danger"
                type={types.NOTIFICATION_ERROR}
                formikProps={formik_props}
              >
                <ErrorMessage name="password" component="div"
                              data-testid="errors-password"
                              className="field-error"/>
                <ErrorMessage name="password_confirm" component="div"
                              data-testid="errors-password_confirm"
                              className="field-error"/>
              </Messages>
              <Messages color="success" notificationId="loginSuccessMessages"/>
              <Form className="verify-admin-page__form">
                <PasswordField name="password"
                               handleBlur={formik_props.handleBlur}/>
                <PasswordField name="password_confirm"
                               handleBlur={formik_props.handleBlur}/>
                <div className="verify-admin-page__actions text-center">
                  <FormattedMessage id="app.admin.verify.admin_verify_submit">
                    {
                      valueBtn => <Field name="submit"
                                         className="verify-admin-page__submit my-4 btn btn-info"
                                         color="info" type="submit"
                                         value={valueBtn}/>
                    }
                  </FormattedMessage>
                </div>
              </Form>
            </Fragment>
          )}
        </Formik>
      </Auth>
      <div className="verify-admin-page__links">
        <LoginLinks forgotLink={goToForgotPassword}
                    loginLink={goToLogin}
        />
      </div>
    </div>
  );
}

VerifyAdminComponent.defaultProps = {
  goToForgotPassword,
  goToLogin
};

const mapActionsToProps = {
  requestVerify,
};

const VerifyAdmin = connect( null, mapActionsToProps )( VerifyAdminComponent );

export { VerifyAdmin, VerifyAdminComponent };
